import React from 'react';
import type { AuthPromptStatus } from '../../controllers/IntegrationsController';
import IntegrationUpgradePrompt from '../../integrations/IntegrationUpgradePrompt';
import type { WhiteboardIntegration } from '../../shared-types';
import Message from './Message';
import IntegrationAuthPrompt from '../../integrations/IntegrationAuthPrompt';

export type MessageComponentType = 'plain' | 'error' | 'success';

export type WhiteboardMessage =
  | { type: 'integrationUpgradePrompt'; integration: WhiteboardIntegration }
  | { type: MessageComponentType; message: string };

type CombinedWhiteboardMessage = WhiteboardMessage | AuthPromptStatus;

const WhiteboardMessageComponent: React.FC<{
  message?: CombinedWhiteboardMessage;
}> = ({ message }) => {
  if (!message) return null;

  if ('type' in message) {
    switch (message.type) {
      case 'integrationUpgradePrompt':
        return <IntegrationUpgradePrompt integration={message.integration} />;
      default:
        return <Message type={message.type}>{message.message}</Message>;
    }
  } else {
    return <IntegrationAuthPrompt authPromptStatus={message} />;
  }
};

export default WhiteboardMessageComponent;
